module.exports = "<div *ngIf=\"messages.length\">\n\n  <h2>DEBUG:</h2>\n  <div *ngFor='let message of messages'> {{message}} </div>\n\n</div>\n"